<mat-card class="standard-card"
  [ngClass]="{'active-card': isActiveStandardCard}"
  (click)="navigateToStandard(scopeSequenceStandard?.standardId)"
  (enter)="navigateToStandard(scopeSequenceStandard?.standardId)"
  (keydown.enter)="navigateToStandard(scopeSequenceStandard?.standardId)">
  <div class="standard-content-wrapper" [ngClass]="{'active-standard-content-wrapper': isActiveStandardCard}">
    <div class="standard-content">
      <mat-card-header class="standard-card-header">
        <mat-card-title>
          <h4 class="standard-title">
            {{scopeSequenceStandard?.standardName}}: {{scopeSequenceStandard?.standardDescription}}
          </h4>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="standard-card-content">
        <div class="standard-container">
          <div class="vertical-bar"></div>
          <div class="description-container">
            <ng-container *ngIf="isActiveStandardCard; else inactiveDescription">
              <span data-test="skill description" class="description" *ngFor="let skillName of scopeSequenceStandard?.skillNames" [innerHTML]="skillName"></span>
            </ng-container>
            <ng-template #inactiveDescription>
              <span class="description no-skills-description">{{ getNoSkillsAlignedText() }}</span>
            </ng-template>
          </div>
        </div>
      </mat-card-content>
    </div>
    <span *ngIf="isActiveStandardCard" class="glyph-chevron-next chevron-right"></span>
  </div>
</mat-card>
